
import { useState, useEffect } from "react";
import { Profile } from "@/hooks/profile/types";
import { toast } from "@/hooks/use-toast";

interface UseCompleteProfileModalProps {
  profile: Profile;
  forceOpen?: boolean;
}

export const useCompleteProfileModal = ({ profile, forceOpen = false }: UseCompleteProfileModalProps) => {
  const [open, setOpen] = useState(false);

  // Show modal if profile is incomplete or if forceOpen is true
  useEffect(() => {
    const isProfileIncomplete = !profile.first_name || !profile.last_name || !profile.birthdate;
    console.log("Profile check in modal:", { 
      forceOpen, 
      isProfileIncomplete, 
      first_name: profile.first_name, 
      last_name: profile.last_name, 
      birthdate: profile.birthdate 
    });
    
    if (forceOpen || isProfileIncomplete) {
      setOpen(true);
    }
  }, [profile, forceOpen]);

  // Prevent navigation while modal is forced open
  useEffect(() => {
    if (forceOpen && open) {
      const handleBeforeUnload = (e: BeforeUnloadEvent) => {
        e.preventDefault();
        e.returnValue = 'Debes completar tu perfil antes de continuar';
        return 'Debes completar tu perfil antes de continuar';
      };

      const handlePopState = (e: PopStateEvent) => {
        e.preventDefault();
        window.history.pushState(null, '', window.location.href);
        toast({
          variant: "destructive",
          title: "Completa tu perfil",
          description: "Debes completar todos los campos antes de continuar.",
        });
      };

      window.addEventListener('beforeunload', handleBeforeUnload);
      window.addEventListener('popstate', handlePopState);
      
      // Prevent back navigation
      window.history.pushState(null, '', window.location.href);

      return () => {
        window.removeEventListener('beforeunload', handleBeforeUnload);
        window.removeEventListener('popstate', handlePopState);
      };
    }
  }, [forceOpen, open]);

  return {
    open,
    setOpen
  };
};
